/** @format */

// import {filter} from "lodash";
import React, { useState, useEffect } from "react";
// material
import {
  Button,
  Box,
  Card,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
  CircularProgress,
  CardContent,
  CardHeader,
  Tabs,
  Tab,
  Grid,
  DialogContent,
} from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
// import SearchToolbar from "../../reusables/table/SearchToolbar";
import SortableTableHeader from "../../reusables/table/SortableTableHeader";
//
import Dialog from "@mui/material/Dialog";
import { useNavigate } from "react-router-dom";
import Iconify from "../../components/Iconify";
import {
  applySortFilter,
  getComparator,
} from "../../reusables/table/SortFilterUtils";
import SearchNotFound from "../../components/SearchNotFound";
// import TableMenuDropdown from "../../reusables/table/TableMenuDropdown";
// import TableMenuItem from "../../reusables/table/TableMenuItem";
// import PhoneNumber from "../../dao/PhoneNumber";
import Waba from "../../dao/Waba";
import Select from "react-select";
// import swal from "../../reusables/CustomSwal";

// import { FaCheckDouble, FaRegCalendar, FaRegCheckCircle } from "react-icons/fa";

import qs from "qs";
import { useLocation } from "react-router";
import { Row, Col } from "react-bootstrap";

import moment from "moment";
import TextFormatter from "../../utils/TextFormatter";

// import bniLogo from "../../assets/bank/bni.png";
// import mandiriLogo from "../../assets/bank/mandiri.png";
// import bcaLogo from "../../assets/bank/bca.png";
// import briLogo from "../../assets/bank/bri.png";
import BillingInvoice from "./BillingInvoice";
import infomediaLogo from "src/assets/infomediaLogo";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import CardBilling from "./CardBilling";
// import { borderRadius } from "@mui/system";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "name", label: "Display Name", alignCenter: true },
  { id: "phone_number", label: "Number Phone", alignCenter: true },
  { id: "status", label: "Status", alignCenter: true },
  { id: "balance", label: "Balance", alignCenter: true },
  { id: "expired", label: "Expired", alignCenter: true },
];

const TABLE_HEAD_PAGE_2 = [
  { id: "date", label: "Date", alignCenter: true },
  { id: "credit", label: "Top Up Credits", alignCenter: true },
  { id: "valid_until", label: "Valid Until", alignCenter: true },
  { id: "row.total_payment", label: "Total Payment", alignCenter: true },
  { id: "status", label: "Status" },
];

const placeholderData = [
  {
    name: "PT Infomedia Nusantara",
    phone_number: "+6281231238",
    balance: 200000000,
    expired: new Date(),
    status: "Business Account",
  },
  {
    name: "PT Telkom Indonesia",
    phone_number: "+6281231238",
    balance: 350000000,
    expired: new Date(),
    status: "Business Account",
  },
];

const placeholderDataPage2 = [
  {
    date: new Date(),
    credit: 385500000,
    valid_until: new Date(),
    total_payment: 350000000,
    status: "Success",
  },
  {
    date: new Date(),
    credit: 10000000,
    valid_until: new Date(),
    total_payment: 11000000,
    status: "Waiting",
  },
  {
    date: new Date(),
    credit: 10000000,
    valid_until: new Date(),
    total_payment: 11000000,
    status: "Cancelled",
  },
];
// ----------------------------------------------------------------------
export default function BillingList(props) {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  let idParam = queryParams.waba_id;

  const [activeMenu, setActiveMenu] = useState(0);

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("F");
  //   const [filterName, setFilterName] = useState("");
  const [filterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  //   const [data, setData] = useState([...placeholderData]);
  //   const [historyData, setHistoryData] = useState([...placeholderDataPage2]);
  //   const [isDataFetched, setIsDataFetched] = useState(true);

  const [data] = useState([...placeholderData]);
  const [historyData] = useState([...placeholderDataPage2]);
  const [isDataFetched] = useState(true);
  const [showDetailModal, setShowDetailModal] = useState(false);
  //   const [detailItem, setDetailItem] = useState({});
  const [setDetailItem] = useState({});

  const [wabaOptions, setWabaOptions] = useState([]);
  const [selectedWabaId, setSelectedWabaId] = useState(null);
  const [selectedWabaLabel, setSelectedWabaLabel] = useState(null);
  const [setCount] = useState(page * rowsPerPage + 1);

  const getWabas = async () => {
    try {
      let result = await Waba.getMyWaba();
      // console.log(result);
      //let templates = result.map((el) => ({...el.profile, role: el.role}));

      let formatted = result.map((obj) => {
        return {
          label: `${obj.name} (${obj.waba_id})`,
          value: obj.waba_id,
        };
      });

      if (formatted.length > 0) {
        let wabaFromParam = formatted.find((obj) => obj.value === idParam);

        if (wabaFromParam && idParam) {
          setSelectedWabaId(wabaFromParam.value);
          setSelectedWabaLabel(wabaFromParam.label);
        } else {
          setSelectedWabaId(formatted[0].value);
          setSelectedWabaLabel(formatted[0].label);
        }
      }

      setWabaOptions(formatted);
    } catch (e) {
      // nothing
    }
  };

  useEffect(() => {
    getWabas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //   let count =

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCount(page * rowsPerPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  //   const handleFilterByName = (event) => {
  //     setFilterName(event.target.value);
  //   };

  //   const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage) : 0;
  const filteredData = applySortFilter(
    data,
    getComparator(order, orderBy),
    filterName,
    "broadcast_name"
  );
  const notFound = filteredData.length === 0;

  /*   const getLogo = () => {
      if (paymentMethod === "BNI") {
        return bniLogo;
      }
      if (paymentMethod === "MANDIRI") {
        return mandiriLogo;
      }
      if (paymentMethod === "BCA") {
        return bcaLogo;
      }
      if (paymentMethod === "BRI") {
        return briLogo;
      }
    }; */

  function makePdf() {
    var docDefinition = {
      pageSize: "A4",
      pageMargins: [30, 60, 30, 60],
      content: [
        {
          columns: [
            {
              image: infomediaLogo,
              width: 100,
            },
            [
              { text: "PT. Infomedia Nusantara", style: "bold" },
              { text: "Jl. Fatmawati Jakarta Selatan" },
            ],
          ],
          margin: [40, 10, 40, 20],
        },
        {
          layout: "noBorders",
          table: {
            headerRows: 0,
            widths: ["*", "*"],
            body: [
              [
                { text: "Invoice", style: "fontMed_bold" },
                {
                  text: new moment().format("DD-MM-YYYY hh:mm:ss"),
                  style: "right",
                },
              ],
              [{ text: "INV/INF/001", style: "bold" }, ""],
            ],
          },
          style: "table",
          margin: [40, 0, 40, 10],
        },
        {
          text: "Summary Purchase",
          style: "fontMed_bold",
          margin: [40, 0, 40, 10],
        },
        {
          layout: "noBorders",
          table: {
            headerRows: 0,
            widths: ["*", "*"],
            body: [
              [
                { text: "Credits", style: "" },
                {
                  text: "Rp1.000.000",
                  style: "right",
                },
              ],
              [
                { text: "Tax (11%)", style: "" },
                {
                  text: "Rp110.000",
                  style: "right",
                },
              ],
            ],
          },
          margin: [40, 0, 40, 10],
        },
        {
          layout: "headerLineOnly",
          table: {
            headerRows: 0,
            widths: ["*", "*"],
            body: [
              [
                { text: "Total Amount", style: "bold" },
                {
                  text: "Rp1.110.000",
                  style: "right_bold",
                },
              ],
            ],
          },
          margin: [40, 0, 40, 10],
        },
        {
          stack: [
            [
              {
                text: "Contact Information",
                style: "fontMed_bold",
              },
              "   ",
              { text: "Zeman Mustohid", style: "bold" },
              "zaemanmustohid21@gmail.com",
              { text: "PT. Infomedia Nusantara", style: "bold" },
              "Jl. Fatmawati Jakarta Selatan",
            ],
          ],
          margin: [40, 0, 40, 10],
        },
      ],
      defaultStyle: {
        //lineHeight: 1.6,
        //alignment: "center",
        columnGap: 20,
      },
      styles: {
        header: {
          fontSize: 30,
          bold: true,
          alignment: "center",
          lineHeight: 1.6,
        },
        header2: {
          fontSize: 18,
          alignment: "center",
          lineHeight: 1.6,
        },
        fontMed_bold: {
          fontSize: 18,
        },
        right: {
          alignment: "right",
        },
        right_bold: {
          alignment: "right",
          bold: true,
        },
        bold: {
          bold: true,
        },
        center: {
          alignment: "center",
        },
        table: {
          width: "100%",
        },
        center_italic: {
          italics: true,
          alignment: "center",
        },
      },
    };
    pdfMake.createPdf(docDefinition).print();
  }

  const detailModal = () => (
    <Dialog
      maxWidth={"md"}
      open={showDetailModal}
      onClose={() => setShowDetailModal(false)}
      //             // aria-labelledby="modal-modal-title"
      // aria-describedby="modal-modal-description"
    >
      <DialogContent>
        <Box>
          <Card style={{ marginTop: 10 }}>
            <CardContent>
              <div
                style={{
                  weight: "bold",
                  color: "black",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <h5 style={{ marginBottom: 0, paddingBottom: 0 }}>
                  Review Order
                </h5>
              </div>
              <div
                style={{
                  height: 1,
                  width: "100%",
                  marginTop: 5,
                  marginBottom: 5,
                  backgroundColor: "lightgray",
                }}
              ></div>

              <Row style={{ marginTop: 15, fontSize: "0.9em" }}>
                <Col md={6}>
                  <BillingInvoice />
                </Col>
                <Col md={6}>
                  <Card style={{ height: "100%" }}>
                    <CardHeader
                      title={<h5>Pembayaran Telah Diterima</h5>}
                      sx={{
                        color: "white",
                        backgroundColor: "#6160dc",
                        textAlign: "center",
                        alignItems: "center",
                        alignContent: "center",
                        display: "flex",
                      }}
                    />
                    <CardContent
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          flex: 1,
                          justifyContent: "center",
                          textAlign: "center",
                          marginTop: "10px",
                          padding: "0 30px",
                        }}
                      >
                        <h4>
                          <b>Hi User</b>
                        </h4>
                        <br />
                        <br />
                        <p>
                          Pembayaran kamu sejumlah{" "}
                          <b>{TextFormatter.moneyFormatter(1110000)}</b> sudah
                          kami terima dan akan kami proses dalam 2 jam kedepan
                          ya
                        </p>
                        <br />
                        <p>Terima Kasih!</p>
                        <p>Infomedia</p>
                        <img
                          src="/static/Infomedia-Nusantara.jpg"
                          width="100px"
                          style={{ margin: "0 auto" }}
                          alt="infomed"
                        />

                        <Button
                          style={{ marginTop: 30 }}
                          variant="contained"
                          onClick={() => makePdf()}
                        >
                          Download as PDF
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
                </Col>
              </Row>
            </CardContent>
          </Card>
        </Box>
      </DialogContent>
    </Dialog>
  );

  return (
    <Page title="Credits">
      <Container>
        <Stack direction="column" mb={5}>
          <Typography variant="h4" gutterBottom>
            Main Credits
          </Typography>
          <div>Manage Credits</div>
        </Stack>

        <Stack
          style={{
            marginBottom: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          direction="row"
        >
          <small>Filter by Waba ID :</small>
          <div style={{ width: 300 }}>
            <Select
              onChange={(option) => {
                // console.log(option);
                setSelectedWabaId(option.value);
                setSelectedWabaLabel(option.label);
              }}
              value={{
                label: selectedWabaLabel,
                value: selectedWabaId,
              }}
              options={wabaOptions}
            />
          </div>
        </Stack>
        <Row
          style={{
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <Col md={12}>
            <Card>
              <CardContent>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <Tabs
                      style={{ flex: 1 }}
                      value={activeMenu}
                      aria-label="basic tabs example"
                    >
                      <Tab
                        onClick={() => {
                          setActiveMenu(0);
                        }}
                        label={
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Iconify
                              icon="ph:credit-card-fill"
                              width={22}
                              height={22}
                              sx={{ marginRight: 1 }}
                            />
                            <div>Credits</div>
                          </div>
                        }
                      />
                      <Tab
                        onClick={() => {
                          setActiveMenu(1);
                        }}
                        label={
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Iconify
                              icon="material-symbols:refresh"
                              width={22}
                              height={22}
                              sx={{ marginRight: 1 }}
                            />
                            <div>History</div>
                          </div>
                        }
                      />
                    </Tabs>
                    {activeMenu === 0 && (
                      <>
                        <Button
                          onClick={() => {
                            navigate("/purchase/create/" + selectedWabaId);
                          }}
                          size={"small"}
                          style={{
                            backgroundColor: "#6160dc",
                            borderColor: "#6160dc",
                            fontWeight: 100,
                            paddingLeft: 50,
                            paddingRight: 50,
                            marginBottom: 10,
                            boxShadow: "none",
                          }}
                          variant={"contained"}
                        >
                          Top Up Credits
                        </Button>
                      </>
                    )}
                  </div>
                  {activeMenu === 0 && (
                    // <Box sx={{ margin: "20px" }}>
                    <Grid item xs={12} sm={12} md={12} direction={"row"} m={2}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <CardBilling
                            value={TextFormatter.moneyFormatter(10000000)}
                            icon={"mdi:money"}
                            title={"Main Credits"}
                            valid={new Date()}
                          />
                        </Grid>
                        {/* <Grid item xs={12} md={6}>
                          <CardBilling
                            value={""}
                            icon={""}
                            title={""}
                            valid={""}
                          />
                        </Grid> */}
                      </Grid>
                    </Grid>
                    // </Box>
                  )}
                </div>
              </CardContent>
            </Card>

            {activeMenu === 0 ? (
              <Card style={{ marginTop: 10 }}>
                <Scrollbar>
                  <TableContainer sx={{ minWidth: 800 }}>
                    <Table style={{ backgroundColor: "white", color: "white" }}>
                      <SortableTableHeader
                        order={order}
                        orderBy={orderBy}
                        headLabel={TABLE_HEAD}
                        onRequestSort={handleRequestSort}
                      />
                      <TableBody>
                        {filteredData
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row) => {
                            const {
                              name,
                              phone_number,
                              balance,
                              expired,
                              status,
                            } = row;
                            return (
                              <TableRow
                                hover
                                key={row.id}
                                tabIndex={-1}
                                role="checkbox"
                              >
                                <TableCell align="center">{name}</TableCell>
                                <TableCell align="center">
                                  {phone_number}
                                </TableCell>
                                <TableCell align="center">{status}</TableCell>
                                <TableCell align="center">
                                  {TextFormatter.moneyFormatter(balance)}
                                </TableCell>
                                <TableCell align="center">
                                  {moment(expired).format("DD MMM YYYY")}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        {/*{emptyRows > 0 && (*/}
                        {/*  <TableRow style={{height: 53 * emptyRows}}>*/}
                        {/*    <TableCell colSpan={6}/>*/}
                        {/*  </TableRow>*/}
                        {/*)}*/}
                      </TableBody>
                      {(notFound || !isDataFetched) && (
                        <TableBody>
                          <TableRow>
                            <TableCell
                              align="center"
                              colSpan={6}
                              sx={{ py: 3 }}
                            >
                              {!isDataFetched ? (
                                <CircularProgress />
                              ) : (
                                <SearchNotFound searchQuery={filterName} />
                              )}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>
                </Scrollbar>

                <TablePagination
                  rowsPerPageOptions={[10, 20, 50, 100]}
                  component="div"
                  count={data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Card>
            ) : (
              <Card style={{ marginTop: 10 }}>
                <Scrollbar>
                  <TableContainer sx={{ minWidth: 800 }}>
                    <Table style={{ backgroundColor: "white", color: "white" }}>
                      <SortableTableHeader
                        order={order}
                        orderBy={orderBy}
                        headLabel={[
                          ...TABLE_HEAD_PAGE_2,
                          {
                            id: "action",
                            label: "",
                            alignCenter: true,
                          },
                        ]}
                        onRequestSort={handleRequestSort}
                      />
                      <TableBody>
                        {historyData
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row) => {
                            const { date, credit, valid_until, status } = row;

                            let formattedStatus = status;
                            if (status === "Success") {
                              formattedStatus = "Success & Paid";
                            }
                            if (status === "Waiting") {
                              formattedStatus = "Waiting Payment";
                            }
                            if (status === "Cancelled") {
                              formattedStatus = "Cancelled";
                            }

                            return (
                              <TableRow hover key={row.id} tabIndex={-1}>
                                <TableCell align="center">
                                  {moment(date).format("DD MMM YYYY")}
                                </TableCell>
                                <TableCell align="center">
                                  {TextFormatter.moneyFormatter(credit)}
                                </TableCell>
                                <TableCell align="center">
                                  {moment(valid_until).format("DD MMM YYYY")}
                                </TableCell>
                                <TableCell align="center">
                                  {TextFormatter.moneyFormatter(
                                    row.total_payment
                                  )}
                                </TableCell>
                                <TableCell align="left">
                                  <Stack
                                    direction="row"
                                    spacing={1}
                                    alignItems="center"
                                  >
                                    <Iconify
                                      icon="akar-icons:circle-fill"
                                      height={10}
                                      sx={{
                                        color:
                                          status === "Success"
                                            ? "#57d95a"
                                            : status === "Waiting"
                                            ? "#ffb74a"
                                            : status === "Cancelled"
                                            ? "#d90e0e"
                                            : "#727272",
                                      }}
                                    />
                                    <Typography variant="p">
                                      {formattedStatus}
                                    </Typography>
                                  </Stack>
                                </TableCell>
                                <TableCell align="center">
                                  <Button
                                    onClick={() => {
                                      setDetailItem(row);
                                      // console.log(row);
                                      setShowDetailModal(true);
                                    }}
                                    variant="contained"
                                  >
                                    View
                                  </Button>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        {/*{emptyRows > 0 && (*/}
                        {/*  <TableRow style={{height: 53 * emptyRows}}>*/}
                        {/*    <TableCell colSpan={6}/>*/}
                        {/*  </TableRow>*/}
                        {/*)}*/}
                      </TableBody>
                      {(notFound || !isDataFetched) && (
                        <TableBody>
                          <TableRow>
                            <TableCell
                              align="center"
                              colSpan={6}
                              sx={{ py: 3 }}
                            >
                              {!isDataFetched ? (
                                <CircularProgress />
                              ) : (
                                <SearchNotFound searchQuery={filterName} />
                              )}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>
                </Scrollbar>

                <TablePagination
                  rowsPerPageOptions={[10, 20, 50, 100]}
                  component="div"
                  count={data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Card>
            )}
          </Col>
        </Row>
        {detailModal()}
      </Container>
    </Page>
  );
}
